import { FC } from "react";
import { FormattedMessage } from "react-intl";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

const languages = [
  { value: "en", labelId: "settings.englishLang", defaultMessage: "English" },
  { value: "fr", labelId: "settings.frenchLang", defaultMessage: "French" },
];

interface SettingsLangProps {
  locale: string;
  onLocaleChange: (locale: string) => void;
}

export const SettingsLang: FC<SettingsLangProps> = ({
  locale,
  onLocaleChange,
}) => {
  return (
    <div className="w-full flex flex-col gap-2">
      <span className="text-sm font-medium">
        <FormattedMessage id="settings.language" defaultMessage={"Language"} />
      </span>
      <Select value={locale} onValueChange={onLocaleChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select a language" />
        </SelectTrigger>
        <SelectContent>
          {languages.map(({ value, labelId, defaultMessage }) => (
            <SelectItem key={value} value={value}>
              <FormattedMessage id={labelId} defaultMessage={defaultMessage} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
